module.exports = __webpack_public_path__ + "img/sokovi.c02507a8.jpg";